module.exports = __webpack_public_path__ + "assets/contact-rainmakers.6342a6af.png";